/* Search page: live results while typing. Fetches the search page with
   section_id and swaps the results area, keeping focus in the field. */
(() => {
  const SEL = '[data-main-search]';
  const root = () => document.querySelector(SEL);
  let timer;
  let controller;
  const cache = {};

  function buildUrl(q, withSection) {
    const form = root().querySelector('[data-search-form]');
    const params = new URLSearchParams(new FormData(form));
    params.set('q', q);
    if (withSection) params.set('section_id', root().dataset.sectionId);
    return form.getAttribute('action') + '?' + params.toString();
  }

  async function run(q) {
    const r = root();
    if (!r) return;
    const results = r.querySelector('[data-search-results]');
    const clear = r.querySelector('[data-search-clear]');
    clear && (clear.hidden = !q);
    const pageUrl = q ? buildUrl(q, false) : r.querySelector('[data-search-form]').getAttribute('action');
    const url = q ? buildUrl(q, true) : pageUrl + '?section_id=' + r.dataset.sectionId;

    controller && controller.abort();
    controller = new AbortController();
    results.classList.add('is-loading');
    try {
      let html = cache[url];
      if (!html) {
        html = await fetch(url, { signal: controller.signal }).then(res => res.text());
        cache[url] = html;
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-search-results]');
      if (fresh) {
        results.innerHTML = fresh.innerHTML;
        window.TINOR && window.TINOR.init(results);
      }
      history.replaceState(null, '', pageUrl);
    } catch (err) {
      if (err.name !== 'AbortError') window.location.href = pageUrl;
    } finally {
      results.classList.remove('is-loading');
    }
  }

  document.addEventListener('input', e => {
    const input = e.target.closest(SEL + ' [data-search-input]');
    if (!input) return;
    clearTimeout(timer);
    const q = input.value.trim();
    timer = setTimeout(() => run(q), 280);
  });

  document.addEventListener('submit', e => {
    const form = e.target.closest(SEL + ' [data-search-form]');
    if (!form) return;
    e.preventDefault();
    clearTimeout(timer);
    const input = form.querySelector('[data-search-input]');
    run(input.value.trim());
    input.blur();
  });

  document.addEventListener('click', e => {
    const r = e.target.closest(SEL);
    if (!r) return;
    const input = r.querySelector('[data-search-input]');
    const chip = e.target.closest('[data-search-term]');
    if (chip) {
      e.preventDefault();
      input.value = chip.dataset.searchTerm;
      run(input.value);
      return;
    }
    if (e.target.closest('[data-search-clear]')) {
      e.preventDefault();
      input.value = '';
      input.focus();
      run('');
    }
  });
})();
